import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Alert,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updateLead } from '../../../../redux/actions/lead';
import { useNegociationValidation } from './formik';
import { CONTACT_METHOD_OPTIONS } from '../../constants';

function NegociationForm({ leadId, leadOrder, onSubmit, onCancel }) {
  const dispatch = useDispatch();
  const updateState = useSelector((state) => state.lead.update);
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const formik = useNegociationValidation((values) => {
    setLoading(true);
    setErrorMessage('');

    if (!leadId) {
      setErrorMessage('No se puede procesar: ID de lead no válido.');
      setLoading(false);
      return;
    }

    const leadInfo = {
      state: 'negotiation',
      contactMethod: values.contactMethod,
      order: leadOrder,
    };

    dispatch(updateLead(leadId, leadInfo));
  });

  const toggle = (operation) => {
    setModal(!modal);
    if (operation === 'submit') {
      onSubmit();
    } else {
      onCancel();
    }
  };

  useEffect(() => {
    if (updateState) {
      setLoading(false);

      if (updateState.status === 'success') {
        toggle('submit');
      } else if (updateState.status === 'danger') {
        setErrorMessage(updateState.message || 'Error al actualizar el lead');
      }
    }
  }, [updateState]);

  return (
    <Modal isOpen={modal} toggle={() => toggle('cancel')}>
      <ModalHeader toggle={() => toggle('cancel')}>Negociación</ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          {errorMessage && (
            <Alert color="danger" className="mb-3">
              {errorMessage}
            </Alert>
          )}

          <p>
            Selecciona el método de contacto que el cliente utilizó para
            comunicarse con nosotros.
          </p>

          <FormGroup className="mb-3">
            <Label for="contactMethod">Método de contacto</Label>
            <Input
              type="select"
              name="contactMethod"
              id="contactMethod"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contactMethod}
              valid={
                formik.touched.contactMethod && !formik.errors.contactMethod
              }
              invalid={
                formik.touched.contactMethod && !!formik.errors.contactMethod
              }
            >
              <option value="">Selecciona un método de contacto</option>
              {CONTACT_METHOD_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
            <FormFeedback>{formik.errors.contactMethod}</FormFeedback>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            disabled={!formik.isValid || !formik.dirty || loading}
          >
            {loading ? 'Procesando...' : 'Enviar'}
          </Button>{' '}
          <Button color="secondary" onClick={() => toggle('cancel')}>
            Cancelar
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default NegociationForm;
